import React, { useState, useEffect, useRef } from 'react';
import MUIRichTextEditor from 'mui-rte';
import { Box, Typography } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";

const TextEditor = ({ value, editorState, setEditorState, handleSave }) => {
    const editorRef = useRef(null);

    useEffect(() => {
        if (value) {
            setEditorState(value);
        }
    }, [value]);


    const myTheme = createTheme({
        components: {
            MUIRichTextEditor: {
                styleOverrides: {
                    root: {
                        borderRadius: '4px',
                        padding: '10px',
                        minHeight: '200px',
                    },
                    editor: {
                        minHeight: '150px',
                        padding: '0 10px',
                        
                        cursor: 'text',
                        '& ul': {
                            listStyleType: 'disc',
                            paddingLeft: '1.25rem', 
                        },
                        '& ol': {
                            listStyleType: 'decimal',
                            paddingLeft: '1.25rem', 
                        },
                    },
                    editorContainer: {
                        minHeight: '150px',
                        padding: '10px',
                        cursor: 'text',
                    },
                },
            },
        },
    });
    return (
        <ThemeProvider theme={myTheme}>
            <Box sx={{ position: 'relative', mb: 2 }} onClick={() => editorRef.current.focus()}>
                <Typography
                    sx={{
                        position: 'absolute',
                        top: '-10px',
                        left: '15px',
                        backgroundColor: 'white',
                        padding: '0 5px',
                        color: '#858485',
                        fontSize: '0.875rem',
                        fontWeight: 500,
                    }}
                >
                    Description
                </Typography>
                <MUIRichTextEditor
                    editorState={editorState}
                    onChange={setEditorState}
                    inlineToolbar={true}
                    onSave={handleSave}
                    defaultValue={value}
                    controls={[
                        "title",
                        'bold',
                        'italic',
                        'underline',
                        'highlight',
                        'unordered',
                        'ordered',
                        'code',
                        "strikethrough",
                         "undo", 
                         "redo",
                         "numberList", "bulletList",
                         "clear", "save",
                    ]}
                    ref={editorRef}
                />
            </Box>
        </ThemeProvider>
    );
};

export default TextEditor;
